import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

export interface DocumentInfo {
  id: number;
  name: string;
  url: string;
  hash: string;
}

type ViewerType = 'google' | 'office' | 'pdf' | 'url' | 'mammoth';

@Component({
  selector: 'app-document-viewer',
  templateUrl: './document-viewer.component.html',
  styleUrls: ['./document-viewer.component.scss'],
})
export class DocumentViewerComponent implements OnInit {
  @Input() document!: DocumentInfo;

  fileType: 'pdf' | 'office' | 'image' | 'video' | 'unknown' = 'unknown';
  viewerType: ViewerType = 'google';
  isLoading = true;
  hasError = false;

  constructor(public modalService: NgbActiveModal) {}

  ngOnInit(): void {
    this.detectFileType();
  }

  private detectFileType(): void {
    const fileName = this.document.name.toLowerCase();
    const extension = fileName.split('.').pop() || '';

    if (extension === 'pdf') {
      this.fileType = 'pdf';
      this.viewerType = 'google';
    } else if (
      ['doc', 'docx', 'xls', 'xlsx', 'ppt', 'pptx'].includes(extension)
    ) {
      this.fileType = 'office';
      this.viewerType = 'office';
    } else if (['png', 'jpg', 'jpeg', 'gif', 'webp'].includes(extension)) {
      this.fileType = 'image';
    } else if (['mp4', 'webm', 'ogg'].includes(extension)) {
      this.fileType = 'video';
    } else {
      this.fileType = 'unknown';
    }

    console.log(this.fileType, this.viewerType);
  }

  onDocumentLoaded(): void {
    this.isLoading = false;
  }

  onLoad(): void {
    this.isLoading = false;
  }

  onError(): void {
    this.isLoading = false;
    this.hasError = true;
  }

  onClose(): void {
    this.modalService.close();
  }

  downloadFile(): void {
    window.open(this.document.url, '_blank');
  }
}
